import { Box, Button, TextField, IconButton, InputAdornment } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
// import ModalLevel from "../../modal/camiones/modalPermisos";
import ModalCliente from "../../modal/cliente/modalCliente";
import { PostDatos } from "../../services/cliente.services";
import { PostDatosEstante } from "../../services/estante.services";
  import { toast } from "react-toastify";
import ModalCharge from "../../modal/modalCharge";
import { parse } from "@fortawesome/fontawesome-svg-core";
import ModalDepositoAmoxarifado from "../../modal/amoxarifado/modalDeposito";


const Estante = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalClienteOpen, setIsModalClienteOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [selected, setSelected] = useState({
    descripcion: "",
  });

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { id_deposito, descripcion, telefono, pais} = values;

    const valuesToSend = {
      id_deposito: parseInt(id_deposito, 10),
      descripcion: descripcion.toUpperCase()
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await PostDatosEstante(valuesToSend);
      setRegistrationSuccess(true);
      toast.success("Registrado exitosamente", {
      position: "top-center", // o "bottom-center"
});

      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      toast.error("Ocurrió un error al registrar",  {
          position: "top-center", // o "bottom-center"
        });
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleSelectCliente = (cliente) => {
    setSelected(cliente);
    };


  return (
    <Box m="20px">
      <Header title="Registro Estante" subtitle="Registro Estante" />

      {isLoading && <ModalCharge />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          direccion:""
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Id Deposito"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.id_deposito || ""}
                name="id_deposito"
                error={!!touched.id_deposito && !!errors.id_deposito}
                helperText={touched.id_deposito && errors.id_deposito}
                sx={{ gridColumn: "span 2" }}
                 onClick={() => setModalOpen(true)}
              />

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Descripcion Estante"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.descripcion || ""}
                name="descripcion"
                error={!!touched.descripcion && !!errors.descripcion}
                helperText={touched.descripcion && errors.descripcion}
                sx={{ gridColumn: "span 2" }}
              />
             
           
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
               <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: "rgb(206, 220, 0)",
                      color: "black",
                      height: "7vh",
                      width: "10vw",
                      borderRadius: "20px",
                      "&:hover": { backgroundColor: "#bac609" },
                    }}
                  >
                    Guardar
              </Button>
              <ModalDepositoAmoxarifado
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              onSelect={(estante) => {
                setFieldValue("id_deposito", estante.id);

              }}
            />
            </Box>
          </form>
        )}
      </Formik>
      <ModalCharge isLoading={isLoading} />
     
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  id_deposito: yup.number().required("Id_deposito requerida"),
  descripcion: yup.string().required("Descripcion requerida"),
});

export default Estante;